









































































































































































































































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import DropdownFilter from '@ui/Filters/DropdownFilter'
import SuperUserSelector from '@ui/SuperUser/SuperUserSelector'
import SponsorSetSelector from '@ui/Campaign/SponsorSetSelector'
import SupplierSelector from '@ui/Campaign/SupplierSelector'

settings =
  name: 'RecapResourceList'

  vue:
    props: ['recaps', 'bulkActionResultItems', 'filtersOverriden', 'infiniteWrapper', 'options', 'actions']

    components: {
      ResourceList,
      DropdownFilter,
      SuperUserSelector,
      SponsorSetSelector,
      SupplierSelector,
    }

    data: ->
      selectedFilters: []
      selectedRecaps: []

      disabledTarget: false
      pageNumber: 1

      sortList: [
        { field: 'created_at', value: 'Created At' }
        { field: 'start_date', value: 'Start Date' }
        { field: 'due_date', value: 'Due Date' }
        { field: 'ctx.sponsor.org.name', value: 'Brand' }
        { field: 'ctx.supplier.org.name', value: 'Supplier' }
      ]
      selectedSort: ''
      sort: [{ field: 'created_at', order: 'desc' }]

      q: ''
      target:
        scopes: {}
        sponsor_set: []
        suppliers: []
        account_managers: []
        account_coordinators: []
        start_date: []
        due_date: []
        published: false
        not_published: false
        submitted: false
        status:
          not_started: false
          started: false
          completed: false

    computed:
      components: ->
        'recap-resource-list-item': () => import('./RecapResourceListItem')

      title: ->
        @options?.title || 'Recaps'

      resourceKey: ->
        @options?.resourceKey || 'recaps'

      selectedFilterAccountManager: ->
        values = [...@target.account_managers]
        values

      selectedFilterAccountCoordinator: ->
        values = [...@target.account_coordinators]
        values

      selectedFilterBrand: ->
        values = [...@target.sponsor_set]
        values

      selectedFilterSupplier: ->
        values = [...@target.suppliers]
        values

      selectedFilterDates: ->
        values = []
        values.push ...@target.start_date if @target.start_date
        values.push ...@target.due_date if @target.due_date
        values

      selectedFilterStatus: ->
        values = Object.entries(@target.status).filter(([key, value]) => !!value).map(([key]) => key)
        values.push @target.published if @target.published
        values.push @target.not_published if @target.not_published
        values.push @target.submitted if @target.submitted
        values

      actionsForAccountManagerSelector: ->
        select: @selectAccountManager
        unselect: @unselectAccountManager
        unselectAll: @unselectAllAccountManager

      actionsForAccountCoordinatorSelector: ->
        select: @selectAccountCoordinator
        unselect: @unselectAccountCoordinator
        unselectAll: @unselectAllAccountCoordinator

      actionsForBrandSelector: ->
        select: @selectBrand
        unselect: @unselectBrand
        unselectAll: @unselectAllBrand

      actionsForSupplierSelector: ->
        select: @selectSupplier
        unselect: @unselectSupplier
        unselectAll: @unselectAllSupplier

      isPublishableWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getPublishableTarget() }

      isOverdueWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getOverdueTarget() }

      isGutCheckWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getGutCheckTarget() }

      availableSort: ->
        @sortList.filter((sort) => sort.field isnt @sort.field)

    methods:
      hiAddSort: (order) ->
        return unless @selectedSort
        if @sort.find((item) => item.field is @selectedSort)
          @sort.find((item) => item.field is @selectedSort).order = order
        else
          @sort.push { field: @selectedSort, order }
        @selectedSort = ''
        @filterChange()

      hiRemoveSort: (sort) ->
        @sort = @sort.filter((item) => item.field isnt sort.field)
        @filterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @sort = @sort.map((item) ->
          item.order = flippedOrder if item.field is sort.field
          item
        )
        @filterChange()

      sortOrderIcon: (order) ->
        if order == 'asc' then 'fa-arrow-up' else 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) => item.field is field).value

      hiAllRecaps: ->
        @clearFilter()
        @filterChange()

      hiPublishableRecaps: ->
        @target = { ...@target, ...@getPublishableTarget() }
        @hiApplyFilters()

      hiOverdueRecaps: ->
        @target = { ...@target, ...@getOverdueTarget() }
        @hiApplyFilters()

      hiGutCheckRecaps: ->
        @target = { ...@target, ...@getGutCheckTarget() }
        @hiApplyFilters()

      hiInfiniteScroll: (state) ->
        @doInfinityScroll state

      hiFilterChange: ->
        @filterChange()

      hiSearchChange: (q = '') ->
        @q = q
        @filterChange()

      hiClearFilter: ->
        @clearFilter()
        @filterChange()

      hiClearAccountManagerFilter: ->
        @target.account_managers = []
        @filterChange()

      hiClearAccountCoordinatorFilter: ->
        @target.account_coordinators = []
        @filterChange()

      hiClearBrandFilter: ->
        @target.sponsor_set = []
        @filterChange()

      hiClearSupplierFilter: ->
        @target.suppliers = []
        @filterChange()

      hiClearDatesFilter: ->
        @target.start_date = []
        @target.due_date = []
        @filterChange()

      hiClearStatusFilter: ->
        @target.status[key] = false for key of @target.status
        @target.published = false
        @target.not_published = false
        @target.submitted = false
        @filterChange()

      hiApplyFilters: ->
        @$refs.infiniteLoading?.stateChanger?.reset()
        @pageNumber = 1
        @doInfinityScroll()

      hiEdit: (recapId) ->
        if @actions?.hiEdit
          @actions?.hiEdit recapId
        else
          @$router.push { name: 'RecapEditPage', params: { recapId } }

      filterChange: ->
        @pageNumber = 1
        @doInfinityScroll()

      doInfinityScroll: (state) ->
        @actions.fetchResource state, @resourceKey, @targetPayload(), { page: @pageNumber }
        @pageNumber += 1

      targetPayload: ->
        payload =  q: @q, sort: @sort, target: { ...@target }
        payload

      getPublishableTarget: ->
        published: false
        not_published: true
        submitted: true
        status:
          not_started: false
          started: false
          completed: false
        start_date: []
        due_date: []

      getOverdueTarget: ->
        published: false
        not_published: true
        submitted: false
        status:
          not_started: true
          started: true
          completed: false
        start_date: []
        due_date: [
          dayjs().add(-1, 'year').format('YYYY-MM-DD')
          dayjs().format('YYYY-MM-DD')
        ]

      getGutCheckTarget: ->
        published: false
        not_published: false
        submitted: false
        status:
          not_started: false
          started: false
          completed: false
        start_date: [
          dayjs().add(-1, 'year').format('YYYY-MM-DD')
          dayjs().format('YYYY-MM-DD')
        ]
        due_date: [
          dayjs().format('YYYY-MM-DD')
          dayjs().add(1, 'year').format('YYYY-MM-DD')
        ]

      clearFilter: ->
        @target =
          scopes: {}
          account_managers: []
          account_coordinators: []
          sponsor_set: []
          suppliers: []
          start_date: []
          due_date: []
          published: false
          not_published: false
          submitted: false
          status:
            not_started: false
            started: false
            completed: false
        @selectedFilters = []

      selectAccountManager: (option) ->
        @target.account_managers.push option.data
      unselectAccountManager: (option) ->
        @target.account_managers = @target.account_managers.filter((item) -> item.id isnt option.data.id)
      unselectAllAccountManager: ->
        @target.account_managers = []

      selectAccountCoordinator: (option) ->
        @target.account_coordinators.push option.data
      unselectAccountCoordinator: (option) ->
        @target.account_coordinators = @target.account_coordinators.filter((item) -> item.id isnt option.data.id)
      unselectAllAccountCoordinator: ->
        @target.account_coordinators = []

      selectBrand: (option) ->
        @target.sponsor_set.push option.data
      unselectBrand: (option) ->
        @target.sponsor_set = @target.sponsor_set.filter((item) -> item.id isnt option.key)
      unselectAllBrand: ->
        @target.sponsor_set = []

      selectSupplier: (option) ->
        @target.suppliers.push option.data
      unselectSupplier: (option) ->
        @target.suppliers = @target.suppliers.filter((item) -> item.id isnt option.key)
      unselectAllSupplier: ->
        @target.suppliers = []

export default VueOptions.vue settings
